<template>
    <div class="d-inline-block" style="white-space: nowrap;">
        <div :style="{ backgroundColor: props.color }" class="me-2 dot"></div>
        <span style="display: inline-block">{{ props.title }}</span>
    </div>
</template>

<script setup>
const props = defineProps({
    color: {
        required: true,
        default: null
    },
    title: {
        required: false,
        default: 0
    }
});
</script>

<style scoped>
span {
    display: inline-block;
}

.dot{
    height: 8px;
    width: 8px;
    border-radius: 50px;
    display: inline-block;
    vertical-align: initial;
}
</style>